import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function WhyUsSection() {
  const reasons = [{
    title: 'Simple & Clear',
    description: 'No jargon. No unnecessary complexity. Just solutions that make sense for your business.'
  }, {
    title: 'Built for Performance',
    description: 'Everything we design and build is created with usability, speed, and results in mind.'
  }, {
    title: 'Reliable & Structured',
    description: 'We value timelines, communication, and consistent delivery standards.'
  }, {
    title: 'Long-Term Partnership',
    description: "Our work doesn't end at launch — we support growth and evolution."
  }];
  return <Section id="why-us" background="default" data-id="element-191">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-192">
        <div data-id="element-193">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-[#0C0C0C] mb-6" data-id="element-194">
            Why Work With Us
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-195">
            We believe in building digital products that solve real problems.
            Our process is transparent, collaborative, and focused on your
            success.
          </motion.p>

          <div className="space-y-8" data-id="element-196">
            {reasons.map((reason, index) => <motion.div key={reason.title} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start" data-id="element-197">
                <CheckCircle2 className="w-6 h-6 text-[#00316B] mt-1 mr-4 shrink-0" data-id="element-198" />
                <div data-id="element-199">
                  <h3 className="text-xl font-bold font-heading text-[#0C0C0C] mb-2" data-id="element-200">
                    {reason.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-201">
                    {reason.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="relative h-full min-h-[400px] hidden lg:block" data-id="element-202">
          <div className="absolute inset-0 bg-gradient-to-br from-[#E5E7EB] to-[#F3F4F6] rounded-2xl overflow-hidden" data-id="element-203">
            <div className="absolute inset-0 opacity-10 pattern-grid-lg text-[#00316B]" data-id="element-204" />
            {/* Abstract visual representation of structure/process */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 border border-white/50 rounded-xl bg-white/40 backdrop-blur-sm p-8 shadow-lg" data-id="element-205">
              <div className="h-full flex flex-col justify-between" data-id="element-206">
                <div className="w-1/3 h-4 bg-[#00316B]/20 rounded mb-4" data-id="element-207" />
                <div className="space-y-3" data-id="element-208">
                  <div className="w-full h-2 bg-gray-400/20 rounded" data-id="element-209" />
                  <div className="w-5/6 h-2 bg-gray-400/20 rounded" data-id="element-210" />
                  <div className="w-4/6 h-2 bg-gray-400/20 rounded" data-id="element-211" />
                </div>
                <div className="mt-auto flex justify-end" data-id="element-212">
                  <div className="w-12 h-12 rounded-full bg-[#00316B] flex items-center justify-center text-white" data-id="element-213">
                    <CheckCircle2 size={24} data-id="element-214" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}